import Chart from 'chart.js'

const originalLineDraw = Chart.controllers.line.prototype.draw
Chart.helpers.extend(Chart.controllers.line.prototype, {
  draw: function () {
    const chart = this.chart

    const yHighlightRangeArray = chart.config.data.yHighlightRange || []
    yHighlightRangeArray.forEach(function (yHighlightRange) {
      if (yHighlightRange !== undefined) {
        const ctx = chart.chart.ctx

        const yRangeBegin = yHighlightRange.begin
        const yRangeEnd = yHighlightRange.end

        const xaxis = chart.scales['x-axis-0']
        const yaxis = chart.scales['y-axis-0']

        const yRangeBeginPixel = yaxis.getPixelForValue(yRangeBegin)
        const yRangeEndPixel = yaxis.getPixelForValue(yRangeEnd)

        ctx.save()

        ctx.fillStyle = yHighlightRange.backgroundColor

        ctx.fillRect(xaxis.left, Math.min(yRangeBeginPixel, yRangeEndPixel), xaxis.right - xaxis.left,
          Math.max(yRangeBeginPixel, yRangeEndPixel) - Math.min(yRangeBeginPixel, yRangeEndPixel))
        ctx.restore()
      }
    })

    originalLineDraw.apply(this, arguments)
  }
})

export default Chart


// WEBPACK FOOTER //
// ./src/lib/chart.js